import { getQuestionById } from "../../services/defs/internal-api/engagement";
import { getEngagementSurveyQuestions } from "../../services/index";

export const engagementSurveyQuestionsQuery = () => ({
	queryKey: ["EngagementSurveyQuestions"],
	queryFn: () => getEngagementSurveyQuestions(),
	refetchOnWindowFocus: false,
	meta: {
		errorMessage: "There was an error getting the engagement survey questions.",
	},
});

export const questionByIdQuery = (questionId: string) => ({
	queryKey: ["questionById", questionId],
	queryFn: () => getQuestionById(questionId),
});
